export default function validation(input) {
    let errors = {}
    const email_pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const phone_pattern =/^\d{10}$/
    const aadhaar_pattern =/^\d{12}$/
    var status = true;

    if (!input.photo) {
        status = false;
        errors.photo = "Please upload your photo"
    }
    if (!input.name) {
        status = false;
        errors.name = "Please enter your name.";
    }

    if (!input.email) {
        status = false;
        errors.email = "Please enter your email address."
    }

    if (input.email && !email_pattern.test(input.email)) {
        status = false;
        errors.email = "Please enter a valid email address."
    }

    if (!input.phone) {
        status = false;
        errors.phone = "Please enter your phone number."
    }

    if (input.phone && !phone_pattern.test(input.phone)){
        status = false;
        errors.phone = "Please enter 10 digit phone number"
    }
    if (!input.address) {
        status = false;
        errors.address = "Please enter your address"
    }

    if (!input.state) {
        status = false;
        errors.state = "Please  select your state"
    }
  
    if (!input.district) {
        status = false;
        errors.district = "Please  select your district"
    }
    if (!input.pin) {
        status = false;
        errors.pin = "Please enter your pincode"
    }
    if (!input.gender) {
        status = false;
        errors.gender = "Please select your gender"
    }

    if (!input.course) {
        status = false;
        errors.course = "Please select course"
    }
    if (!input.amount) {
        status = false;
        errors.amount = "Please enter fee amount"
    }
    if (!input.aadhaar) {
        status = false;
        errors.aadhaar = "Please upload your aadhaar"
    }
    if (!input.resume) {
        status = false;
        errors.resume = "Please upload your resume"
    }


    return {'errors':errors,'status':status};
}